import { Collapse, CollapseProps } from "antd";
import { Page } from "components/Page";
import { useGetFAQQuery } from "store/api";
import { useSalesNetwork } from "utils/hooks/useSalesNetworks";
import useTranslation from "utils/hooks/useTranslation";

export const FAQPage: React.FC = () => {
  const { language } = useTranslation();
  const { network } = useSalesNetwork();
  const { data: FAQData } = useGetFAQQuery(
    { languageCode: language || "", networkCode: network?.code || "" },
    { skip: !language || !network }
  );

  const items: CollapseProps["items"] = FAQData?.data.map((i) => ({
    key: i.id,
    label: i.question,
    children: i.answer,
  }));

  return (
    <Page title={"FAQ"}>
      <group data-align="center" data-direction="column" data-gap="20">
        <group
          data-gap="40"
          data-space-vertical="30"
          data-wrap="no"
          data-max-length="1440"
        >
          <group data-direction="column">
            <Collapse items={items} />
          </group>
        </group>
      </group>
    </Page>
  );
};
